export default __webpack_public_path__ + "static/media/Snd1.01402866.mp3";